import { Flex, Spinner, Text } from '@chakra-ui/react';

type LoadingProps = {
	label?: string;
};

/**
 * Single loading treatment reused everywhere a full area is waiting on data,
 * so the spinner, spacing and copy read the same across the app.
 */
export const Loading = ({ label = 'Carregando...' }: LoadingProps) => {
	return (
		<Flex
			width="100%"
			minH="200px"
			flex="1"
			direction="column"
			justify="center"
			align="center"
			gap="14px"
			py="60px"
		>
			<Spinner thickness="4px" speed="0.65s" emptyColor="mist" color="blue.500" size="xl" />
			<Text fontSize="16px" fontWeight="600" color="gray.500">
				{label}
			</Text>
		</Flex>
	);
};
